import { Flex } from '@chakra-ui/react';
import { FooterLinkItem } from './FooterLinkItem';
import {
  dsCratD2CLink,
  facebookCratD2CLink,
  linkedinCratD2CLink,
  tgCratD2CLink,
  twCratD2CLink,
  youtubeCratD2CLink,
} from '../../constants/footerLinks';
import { FaDiscord, FaFacebook, FaLinkedinIn, FaTelegramPlane, FaTwitter, FaYoutube } from 'react-icons/fa';
import React from 'react';

export const FooterLinkList = React.memo(() => {
  const linksToMap = [
    { link: tgCratD2CLink, icon: FaTelegramPlane },
    { link: dsCratD2CLink, icon: FaDiscord },
    { link: twCratD2CLink, icon: FaTwitter },
    { link: linkedinCratD2CLink, icon: FaLinkedinIn },
    { link: youtubeCratD2CLink, icon: FaYoutube },
    { link: facebookCratD2CLink, icon: FaFacebook },
  ];

  return (
    <Flex gap="30px">
      {linksToMap.map(({ link, icon }) => (
        <FooterLinkItem link={link} icon={icon} key={link} />
      ))}
    </Flex>
  );
});
